'use client'

import { cn } from '@/lib/tailwind'
import Image from 'next/image'
import type { MediaKind } from '@/entries'
import { ENTRY_PRESENTATION } from '@/entries'
import { truncateText, MAX_TITLE_LENGTH } from './utils'

interface MediaImageProps {
  type: MediaKind
  imageUrl?: string
  title: string
  hasError: boolean
  onError: () => void
}

/**
 * Displays cover art/image for media preview with fallback icon
 */
export function MediaImage({
  type,
  imageUrl,
  title,
  hasError,
  onError,
}: MediaImageProps) {
  // `type` is a `MediaKind`, a subset of `EntryType`, so the record is total over it and
  // the old `|| …movie` fallbacks were unreachable (#390).
  const colors = ENTRY_PRESENTATION[type]
  const Icon = colors.icon

  const hasImage = !!imageUrl

  return (
    <div
      className={cn(
        'relative h-20 w-14 shrink-0 overflow-hidden rounded',
        type === 'artist' || type === 'label' ? 'w-20' : 'w-14',
        colors.bg,
      )}
    >
      {hasImage && !hasError ? (
        <Image
          src={imageUrl}
          alt={truncateText(title, MAX_TITLE_LENGTH)}
          fill
          className="object-cover"
          sizes="80px"
          onError={onError}
        />
      ) : (
        <div className="flex h-full items-center justify-center">
          <Icon className={cn('h-6 w-6', colors.text)} />
        </div>
      )}
    </div>
  )
}
